/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  GrantTemplatePermissionsV2PathParameters,
  LeaveTemplateV2PathParameters,
  ListTemplatePermissionsV2Params,
  ListTemplatePermissionsV2PathParameters,
  RevokeTemplatePermissionsV2PathParameters,
  TLGrantTemplatePermissionsRequest,
  TLHTTPValidationError,
  TLLeaveTemplateResponse,
  TLRevokeTemplatePermissionsRequest,
  TLRevokeTemplatePermissionsResponse,
  TLTemplatePermission,
  TLTemplatePermissionListResponse,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List Template Permissions V2
 */
export const listTemplatePermissionsV2 = (
  { templateId }: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLTemplatePermissionListResponse>(
    { url: `/api/v2/workflow-templates/${templateId}/permissions`, method: 'GET', params, signal },
    options,
  );
};

export const getListTemplatePermissionsV2QueryKey = (
  { templateId }: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
) => {
  return ['api', 'v2', 'workflow-templates', templateId, 'permissions', ...(params ? [params] : [])] as const;
};

export const getListTemplatePermissionsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTemplatePermissionsV2QueryKey({ templateId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplatePermissionsV2>>> = ({ signal }) =>
    listTemplatePermissionsV2({ templateId }, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: templateId !== null && templateId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listTemplatePermissionsV2>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListTemplatePermissionsV2QueryResult = NonNullable<Awaited<ReturnType<typeof listTemplatePermissionsV2>>>;
export type ListTemplatePermissionsV2QueryError = ErrorType<TLHTTPValidationError>;

export function useListTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListTemplatePermissionsV2PathParameters,
  params: undefined | ListTemplatePermissionsV2Params,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplatePermissionsV2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
          TError,
          Awaited<ReturnType<typeof listTemplatePermissionsV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplatePermissionsV2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
          TError,
          Awaited<ReturnType<typeof listTemplatePermissionsV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Template Permissions V2
 */

export function useListTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTemplatePermissionsV2QueryOptions({ templateId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Template Permissions V2
 */
export const prefetchListTemplatePermissionsV2Query = async <
  TData = Awaited<ReturnType<typeof listTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { templateId }: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListTemplatePermissionsV2QueryOptions({ templateId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Template Permissions V2
 */
export const invalidateListTemplatePermissionsV2 = async (
  queryClient: QueryClient,
  { templateId }: ListTemplatePermissionsV2PathParameters,
  params?: ListTemplatePermissionsV2Params,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListTemplatePermissionsV2QueryKey({ templateId }, params) },
    options,
  );

  return queryClient;
};

/**
 * @summary Grant Template Permissions V2
 */
export const grantTemplatePermissionsV2 = (
  { templateId }: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLTemplatePermission[]>(
    {
      url: `/api/v2/workflow-templates/${templateId}/permissions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLGrantTemplatePermissionsRequest,
      signal,
    },
    options,
  );
};

export const getGrantTemplatePermissionsV2QueryKey = (
  { templateId }: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest?: BodyType<TLGrantTemplatePermissionsRequest>,
) => {
  return [
    'POST',
    'api',
    'v2',
    'workflow-templates',
    templateId,
    'permissions',
    tLGrantTemplatePermissionsRequest,
  ] as const;
};

export const getGrantTemplatePermissionsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGrantTemplatePermissionsV2QueryKey({ templateId }, tLGrantTemplatePermissionsRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>> = ({ signal }) =>
    grantTemplatePermissionsV2({ templateId }, tLGrantTemplatePermissionsRequest, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: templateId !== null && templateId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GrantTemplatePermissionsV2QueryResult = NonNullable<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>>;
export type GrantTemplatePermissionsV2QueryError = ErrorType<TLHTTPValidationError>;

export function useGrantTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
          TError,
          Awaited<ReturnType<typeof grantTemplatePermissionsV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGrantTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
          TError,
          Awaited<ReturnType<typeof grantTemplatePermissionsV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGrantTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Grant Template Permissions V2
 */

export function useGrantTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGrantTemplatePermissionsV2QueryOptions(
    { templateId },
    tLGrantTemplatePermissionsRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Grant Template Permissions V2
 */
export const prefetchGrantTemplatePermissionsV2Query = async <
  TData = Awaited<ReturnType<typeof grantTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { templateId }: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof grantTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGrantTemplatePermissionsV2QueryOptions(
    { templateId },
    tLGrantTemplatePermissionsRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Grant Template Permissions V2
 */
export const invalidateGrantTemplatePermissionsV2 = async (
  queryClient: QueryClient,
  { templateId }: GrantTemplatePermissionsV2PathParameters,
  tLGrantTemplatePermissionsRequest: BodyType<TLGrantTemplatePermissionsRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGrantTemplatePermissionsV2QueryKey({ templateId }, tLGrantTemplatePermissionsRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Leave Template V2
 */
export const leaveTemplateV2 = (
  { templateId }: LeaveTemplateV2PathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLLeaveTemplateResponse>(
    { url: `/api/v2/workflow-templates/${templateId}/permissions/me`, method: 'DELETE', signal },
    options,
  );
};

export const getLeaveTemplateV2QueryKey = ({ templateId }: LeaveTemplateV2PathParameters) => {
  return ['DELETE', 'api', 'v2', 'workflow-templates', templateId, 'permissions', 'me'] as const;
};

export const getLeaveTemplateV2QueryOptions = <
  TData = Awaited<ReturnType<typeof leaveTemplateV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: LeaveTemplateV2PathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveTemplateV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLeaveTemplateV2QueryKey({ templateId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof leaveTemplateV2>>> = ({ signal }) =>
    leaveTemplateV2({ templateId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: templateId !== null && templateId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof leaveTemplateV2>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type LeaveTemplateV2QueryResult = NonNullable<Awaited<ReturnType<typeof leaveTemplateV2>>>;
export type LeaveTemplateV2QueryError = ErrorType<TLHTTPValidationError>;

export function useLeaveTemplateV2<
  TData = Awaited<ReturnType<typeof leaveTemplateV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: LeaveTemplateV2PathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveTemplateV2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveTemplateV2>>,
          TError,
          Awaited<ReturnType<typeof leaveTemplateV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLeaveTemplateV2<
  TData = Awaited<ReturnType<typeof leaveTemplateV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: LeaveTemplateV2PathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveTemplateV2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveTemplateV2>>,
          TError,
          Awaited<ReturnType<typeof leaveTemplateV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLeaveTemplateV2<
  TData = Awaited<ReturnType<typeof leaveTemplateV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: LeaveTemplateV2PathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveTemplateV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Leave Template V2
 */

export function useLeaveTemplateV2<
  TData = Awaited<ReturnType<typeof leaveTemplateV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: LeaveTemplateV2PathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveTemplateV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLeaveTemplateV2QueryOptions({ templateId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Leave Template V2
 */
export const prefetchLeaveTemplateV2Query = async <
  TData = Awaited<ReturnType<typeof leaveTemplateV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { templateId }: LeaveTemplateV2PathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveTemplateV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLeaveTemplateV2QueryOptions({ templateId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Leave Template V2
 */
export const invalidateLeaveTemplateV2 = async (
  queryClient: QueryClient,
  { templateId }: LeaveTemplateV2PathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getLeaveTemplateV2QueryKey({ templateId }) }, options);

  return queryClient;
};

/**
 * @summary Revoke Template Permissions V2
 */
export const revokeTemplatePermissionsV2 = (
  { templateId }: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLRevokeTemplatePermissionsResponse>(
    {
      url: `/api/v2/workflow-templates/${templateId}/permissions/revoke`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLRevokeTemplatePermissionsRequest,
      signal,
    },
    options,
  );
};

export const getRevokeTemplatePermissionsV2QueryKey = (
  { templateId }: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest?: BodyType<TLRevokeTemplatePermissionsRequest>,
) => {
  return [
    'POST',
    'api',
    'v2',
    'workflow-templates',
    templateId,
    'permissions',
    'revoke',
    tLRevokeTemplatePermissionsRequest,
  ] as const;
};

export const getRevokeTemplatePermissionsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRevokeTemplatePermissionsV2QueryKey({ templateId }, tLRevokeTemplatePermissionsRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>> = ({ signal }) =>
    revokeTemplatePermissionsV2({ templateId }, tLRevokeTemplatePermissionsRequest, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: templateId !== null && templateId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type RevokeTemplatePermissionsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>
>;
export type RevokeTemplatePermissionsV2QueryError = ErrorType<TLHTTPValidationError>;

export function useRevokeTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
          TError,
          Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRevokeTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
          TError,
          Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRevokeTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Revoke Template Permissions V2
 */

export function useRevokeTemplatePermissionsV2<
  TData = Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { templateId }: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRevokeTemplatePermissionsV2QueryOptions(
    { templateId },
    tLRevokeTemplatePermissionsRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Revoke Template Permissions V2
 */
export const prefetchRevokeTemplatePermissionsV2Query = async <
  TData = Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { templateId }: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeTemplatePermissionsV2>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getRevokeTemplatePermissionsV2QueryOptions(
    { templateId },
    tLRevokeTemplatePermissionsRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Revoke Template Permissions V2
 */
export const invalidateRevokeTemplatePermissionsV2 = async (
  queryClient: QueryClient,
  { templateId }: RevokeTemplatePermissionsV2PathParameters,
  tLRevokeTemplatePermissionsRequest: BodyType<TLRevokeTemplatePermissionsRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getRevokeTemplatePermissionsV2QueryKey({ templateId }, tLRevokeTemplatePermissionsRequest) },
    options,
  );

  return queryClient;
};
